import { render, staticRenderFns } from "./SectionLogos.vue?vue&type=template&id=cbd624b8&scoped=true&"
import script from "./SectionLogos.vue?vue&type=script&lang=js&"
export * from "./SectionLogos.vue?vue&type=script&lang=js&"
import style0 from "./SectionLogos.vue?vue&type=style&index=0&id=cbd624b8&scoped=true&lang=scss&"
import style1 from "./SectionLogos.vue?vue&type=style&index=1&id=cbd624b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbd624b8",
  null
  
)

export default component.exports